import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from '@mui/material';

export default function StatusOptions({ value = 1, onChange }) {
  const handleChange = ({ target: { value: newValue } }) => {
    if (!onChange) return;

    onChange(+newValue);
  };

  return (
    <FormControl>
      <FormLabel>Select status</FormLabel>
      <RadioGroup
        row
        value={value}
        onChange={handleChange}>
        <FormControlLabel
          value={1}
          control={<Radio />}
          label="Enabled"
        />
        <FormControlLabel
          value={0}
          control={<Radio />}
          label="Disabled"
        />
      </RadioGroup>
    </FormControl>
  );
}
